import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import styled, { createGlobalStyle, ThemeProvider, css, useTheme, keyframes } from 'styled-components';
import { XCircle } from 'react-feather';
import React, { useState, useEffect, useMemo } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var ButtonStyled = styled.button(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n"], ["\n"])));
var templateObject_1$c;

var Button$1 = function (_a) {
    var children = _a.children;
    return jsx(ButtonStyled, __assign({ type: "button" }, { children: children }));
};

var padding = {
    'text': '4px 12px',
    'textAndClose': '4px 10px 4px 12px',
    'iconAndText': '4px 12px 4px 10px',
    'iconAndTextAndClose': '4px 10px',
};
var Container$3 = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 50px;\n  margin-top: 3px;\n\n  & > * + *:not(p:not(:first-of-type)) {\n    margin-left: 5px;\n  }\n\n  padding: ", "\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 50px;\n  margin-top: 3px;\n\n  & > * + *:not(p:not(:first-of-type)) {\n    margin-left: 5px;\n  }\n\n  padding: ", "\n"])), function (props) { return props.theme.cores[props.$backgroundColor]; }, function (props) { return props.theme.cores[props.$borderColor]; }, function (props) {
    if (props.icon && props.close) {
        return padding.iconAndTextAndClose;
    }
    else if (props.icon) {
        return padding.iconAndText;
    }
    else if (props.close) {
        return padding.textAndClose;
    }
    else {
        return padding.text;
    }
});
var ClosingArea = styled.span(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 40px;\n"], ["\n  cursor: pointer;\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 40px;\n"])));
var templateObject_1$b, templateObject_2$4;

function Pill(_a) {
    var Icon = _a.Icon, content = _a.content, onClose = _a.onClose, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'GREY-100-BORDER-BG' : _b, _c = _a.borderColor, borderColor = _c === void 0 ? 'none' : _c;
    return (jsxs(Container$3, __assign({ "$backgroundColor": backgroundColor, "$borderColor": borderColor, close: Boolean(onClose), icon: Boolean(Icon) }, { children: [Icon && jsx(Icon, {}), content, onClose && (jsxs(Fragment, { children: [jsx(ClosingArea, { "data-testid": "closing-area", onClick: onClose }), jsx(XCircle, { size: 16 })] }))] })));
}

var SelectWrapper = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  transition: all .3s ease-in-out;\n"], ["\n  transition: all .3s ease-in-out;\n"])));
var SelectStyled = styled.select(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  background-color: transparent;\n  border: 0;\n  box-sizing: border-box;\n  color: ", ";\n  height: 40px;\n\n  width: 100%;\n\n  outline: none;\n\n  &:focus:not([disabled]),\n  &:active:not([disabled]) {\n    border-bottom-color: ", "\n  }\n\n  border-bottom: 2px solid;\n  border-bottom-color: ", ";\n\n\n  option {\n    color: ", "\n  }\n  font-size: ", ";\n\n  font-weight: ", ";\n"], ["\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  background-color: transparent;\n  border: 0;\n  box-sizing: border-box;\n  color: ", ";\n  height: 40px;\n\n  width: 100%;\n\n  outline: none;\n\n  &:focus:not([disabled]),\n  &:active:not([disabled]) {\n    border-bottom-color: ", "\n  }\n\n  border-bottom: 2px solid;\n  border-bottom-color: ", ";\n\n\n  option {\n    color: ", "\n  }\n  font-size: ", ";\n\n  font-weight: ", ";\n"])), function (props) {
    if (props.placeholder && props.value === props.placeholder) {
        return props.theme.coresOpacas.formPlaceholder30;
    }
    return props.theme.cores.cinza500;
}, function (props) { return props.theme.cores.azulForm; }, function (props) {
    if (!props.displayErrorOrSuccess) {
        return props.theme.coresOpacas.formBorder;
    }
    else {
        return props.success ? props.theme.cores.verdeSucesso : props.theme.cores.vermelhoErro;
    }
}, function (props) { return props.theme.cores.cinza500; }, function (props) { return props.theme.fontSize.m; }, function (props) {
    if (props.placeholder && props.value === props.placeholder) {
        return 'bold';
    }
});
var OptionPlaceholder = styled.option(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  color: ", ";\n  opacity: .3;\n"], ["\n  color: ", ";\n  opacity: .3;\n"])), function (props) { return props.theme.cores.cinza500; });
var templateObject_1$a, templateObject_2$3, templateObject_3$1;

var SVG$1 = styled.svg(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  margin: -30px 0 10px;\n  transition:all .3s ease-in-out;\n  align-self: flex-end;\n"], ["\n  margin: -30px 0 10px;\n  transition:all .3s ease-in-out;\n  align-self: flex-end;\n"])));
function ErrorIcon(props) {
    return (jsx(SVG$1, __assign({ height: "20px", width: "20px", xmlns: "http://www.w3.org/2000/svg" }, props, { viewBox: "0 0 40 40" }, { children: jsxs("g", __assign({ fill: "#FC2351", fillRule: "evenodd" }, { children: [jsx("path", { d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm0-2c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18z" }), jsxs("g", __assign({ transform: "translate(18.667 8)" }, { children: [jsx("circle", { cx: 1.467, cy: 20.467, r: 1.467 }), jsx("rect", { height: 16, rx: 1.333, width: 2.667 })] }))] })) })));
}
var templateObject_1$9;

var DivWrapper = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
function Message(_a) {
    var className = _a.className, Icon = _a.Icon, message = _a.message;
    return (jsxs(DivWrapper, __assign({ className: className }, { children: [jsx(Icon, {}), jsx("p", { children: message })] })));
}
var templateObject_1$8;

var ErrorMessage = styled(Message)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  p {\n    color: ", ";\n    font-weight: bold;\n    margin-top: 4px;\n    font-size: ", ";\n    padding-left: 8px;\n    transition: all .3s ease-in-out;\n  }\n"], ["\n  p {\n    color: ", ";\n    font-weight: bold;\n    margin-top: 4px;\n    font-size: ", ";\n    padding-left: 8px;\n    transition: all .3s ease-in-out;\n  }\n"])), function (props) { return props.theme.cores.vermelhoErroCampoObrigatorio; }, function (props) { return props.theme.fontSize.xxs; });
var templateObject_1$7;

var SVG = styled.svg(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  margin: -30px 0 10px;\n  align-self: flex-end;\n  transition:all .3s ease-in-out;\n"], ["\n  margin: -30px 0 10px;\n  align-self: flex-end;\n  transition:all .3s ease-in-out;\n"])));
function SuccessIcon(props) {
    return (jsx(SVG, __assign({ height: "20px", viewBox: "0 0 40 40", width: "20px", xmlns: "http://www.w3.org/2000/svg" }, props, { children: jsxs("g", __assign({ fill: "#34C41A", fillRule: "evenodd" }, { children: [jsx("path", { d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm0-2c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18z" }), jsx("path", { d: "M17.939 26.667a.997.997 0 01-.707-.293l-5.94-5.939a1 1 0 011.415-1.414l5.19 5.19 8.777-9.876a1 1 0 111.495 1.33l-9.483 10.666a1.006 1.006 0 01-.718.336h-.03z" })] })) })));
}
var templateObject_1$6;

function ValidationMessage(_a) {
    var shouldDisplay = _a.shouldDisplay, success = _a.success, errorMessage = _a.errorMessage;
    if (!shouldDisplay) {
        return null;
    }
    return success ?
        jsx(Message, { Icon: SuccessIcon, message: "" }) :
        jsx(ErrorMessage, { Icon: ErrorIcon, message: errorMessage });
}

function Select(_a) {
    var items = _a.items, _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b, selectedItem = _a.selectedItem, _c = _a.success, success = _c === void 0 ? true : _c, errorMessage = _a.errorMessage, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, _d = _a.touched, touched = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e;
    var shouldDisplayPlaceholder = Boolean(placeholder);
    var _f = useState(false), displayErrorOrSuccess = _f[0], setDisplayErrorOrSuccess = _f[1];
    var _g = useState(false), focused = _g[0], setFocused = _g[1];
    useEffect(function () {
        if (touched && !disabled && !focused) {
            setDisplayErrorOrSuccess(true);
        }
        else {
            setDisplayErrorOrSuccess(false);
        }
    }, [touched, disabled, focused]);
    function handleOnChange(evt) {
        onChange === null || onChange === void 0 ? void 0 : onChange(evt.target.value, evt);
    }
    function handleOnFocus(evt) {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(evt.target.value, evt);
    }
    function handleOnBlur(evt) {
        setFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(evt.target.value, evt);
    }
    return (jsxs(SelectWrapper, __assign({ displayErrorOrSuccess: displayErrorOrSuccess, success: success }, { children: [jsxs(SelectStyled, __assign({ "data-testid": "tag-select", disabled: disabled, displayErrorOrSuccess: displayErrorOrSuccess, onBlur: handleOnBlur, onChange: handleOnChange, onFocus: handleOnFocus, placeholder: placeholder, success: success, value: selectedItem }, { children: [shouldDisplayPlaceholder &&
                        jsx(OptionPlaceholder, __assign({ disabled: true, hidden: true }, { children: placeholder }), ""), items && items.map(function (item) { return (jsx("option", __assign({ value: item.value }, { children: item.label }), item.value)); })] })), jsx(ValidationMessage, { errorMessage: errorMessage, shouldDisplay: displayErrorOrSuccess, success: success })] })));
}

var palette = {
    'TAG1-100': '#D0D0E3',
    'TAG1-300': '#767BA7',
    'TAG1-700': '#222F64',
    'TAG1-800': '#091539',
    'TAG1-900': '#010E23',
    'TAG2-50': '#FFF7CC',
    'TAG2-100': '#FFEE99',
    'TAG2-200': '#FFE666',
    'TAG3-200': '#FF769A',
    'TAG3-400': '#EC3C6A',
    'TAG3-600': '#CA234E',
    'INE-50': '#FFEACC',
    'INE-100': '#FFB366',
    'INE-300': '#E67300',
    'INE-700': '#993300',
    'INE-800': '#490F04',
    'CUR-50': '#CCF6EF',
    'CUR-100': '#66DCDE',
    'CUR-400': '#009BBF',
    'CUR-700': '#045B8C',
    'CUR-800': '#052E5B',
    'CTA-200': '#68F15C',
    'CTA-300': '#00A94E',
    'CTA-400': '#008F64',
    'ALERT-100': '#FFB905',
    'ALERT-400': '#EA7000',
    'ERROR-200': '#FF6C6C',
    'ERROR-700': '#E51010',
    'SUCCESS-200': '#72D933',
    'SUCCESS-400': '#00AD11',
    'BLACK': '#000000',
    'WHITE': '#FFFFFF',
};

var Variant;
(function (Variant) {
    (function (FontFamily) {
        /**
         * Highlight texts - titles, subtitles, buttons, etc.
         */
        FontFamily["HEAD"] = "Work Sans";
        /**
         * Descritive texts - text bodies, tooltips, etc.
         */
        FontFamily["BODY"] = "Lato";
    })(Variant.FontFamily || (Variant.FontFamily = {}));
})(Variant || (Variant = {}));
var titleHugeRegular = {
    fontFamily: Variant.FontFamily.HEAD,
    fontSize: {
        desktop: '96px',
        mobile: '64px',
    },
    lineHeight: {
        desktop: '96px',
        mobile: '64px',
    },
    letterSpacing: '-0.02em',
    fontWeight: '400',
};
var titleBigRegular = {
    fontFamily: Variant.FontFamily.HEAD,
    fontSize: {
        desktop: '72px',
        mobile: '56px',
    },
    lineHeight: {
        desktop: '72px',
        mobile: '56px',
    },
    letterSpacing: '-0.02em',
    fontWeight: '400',
};
var titleLargeRegular = {
    fontFamily: Variant.FontFamily.HEAD,
    fontSize: {
        desktop: '56px',
        mobile: '40px',
    },
    lineHeight: {
        desktop: '56px',
        mobile: '40px',
    },
    letterSpacing: '-0.01em',
    fontWeight: '400',
};
var titleMediumRegular = {
    fontFamily: Variant.FontFamily.HEAD,
    fontSize: {
        desktop: '48px',
        mobile: '32px',
    },
    lineHeight: {
        desktop: '48px',
        mobile: '32px',
    },
    letterSpacing: '-0.01em',
    fontWeight: '400',
};
var subtitleLargeRegular = {
    fontFamily: Variant.FontFamily.HEAD,
    fontSize: {
        desktop: '20px',
        mobile: '20px',
    },
    lineHeight: {
        desktop: '24px',
        mobile: '24px',
    },
    letterSpacing: '-0.02em',
    fontWeight: '400',
};
var subtitleMediumRegular = {
    fontFamily: Variant.FontFamily.HEAD,
    fontSize: {
        desktop: '16px',
        mobile: '16px',
    },
    lineHeight: {
        desktop: '20px',
        mobile: '20px',
    },
    letterSpacing: '0.01em',
    fontWeight: '400',
};
var commomTitleBoldWeight = {
    letterSpacing: '-0.03em',
    fontWeight: '700',
};
var commomTitleLightWeight = {
    letterSpacing: '-0.01em',
    fontWeight: '300',
};
var textMediumRegular = {
    fontFamily: Variant.FontFamily.BODY,
    fontSize: {
        desktop: '16px',
        mobile: '14px',
    },
    lineHeight: {
        desktop: '22px',
        mobile: '20px',
    },
    letterSpacing: '0.01em',
    fontWeight: '400',
};
var textSmallRegular = {
    fontFamily: Variant.FontFamily.BODY,
    fontSize: {
        desktop: '12px',
        mobile: '11px',
    },
    lineHeight: {
        desktop: '16px',
        mobile: '14px',
    },
    letterSpacing: '0.01em',
    fontWeight: '400',
};
var commomTextBoldWeight = {
    letterSpacing: '-0.02em',
    fontWeight: '700',
};
var buttonMediumBold = {
    fontFamily: Variant.FontFamily.HEAD,
    fontSize: {
        desktop: '16px',
        mobile: '16px',
    },
    lineHeight: {
        desktop: '16px',
        mobile: '16px',
    },
    letterSpacing: '0.05em',
    fontWeight: '700',
};
var typography = {
    'title-huge-regular': titleHugeRegular,
    'title-big-regular': titleBigRegular,
    'title-large-regular': titleLargeRegular,
    'title-medium-regular': titleMediumRegular,
    'subtitle-large-regular': subtitleLargeRegular,
    'subtitle-medium-regular': subtitleMediumRegular,
    'title-huge-bold': __assign(__assign({}, titleHugeRegular), commomTitleBoldWeight),
    'title-big-bold': __assign(__assign({}, titleBigRegular), commomTitleBoldWeight),
    'title-large-bold': __assign(__assign({}, titleLargeRegular), commomTitleBoldWeight),
    'title-medium-bold': __assign(__assign({}, titleMediumRegular), commomTitleBoldWeight),
    'subtitle-large-bold': __assign(__assign({}, subtitleLargeRegular), commomTitleBoldWeight),
    'subtitle-medium-bold': __assign(__assign({}, subtitleMediumRegular), commomTitleBoldWeight),
    'title-huge-light': __assign(__assign({}, titleHugeRegular), commomTitleLightWeight),
    'title-big-light': __assign(__assign({}, titleBigRegular), commomTitleLightWeight),
    'title-large-light': __assign(__assign({}, titleLargeRegular), commomTitleLightWeight),
    'title-medium-light': __assign(__assign({}, titleMediumRegular), commomTitleLightWeight),
    'subtitle-large-light': __assign(__assign({}, subtitleLargeRegular), commomTitleLightWeight),
    'subtitle-medium-light': __assign(__assign({}, subtitleMediumRegular), commomTitleLightWeight),
    'text-medium-regular': textMediumRegular,
    'text-small-regular': textSmallRegular,
    'text-medium-bold': __assign(__assign({}, textMediumRegular), commomTextBoldWeight),
    'text-small-bold': __assign(__assign({}, textSmallRegular), commomTextBoldWeight),
    'button-medium-bold': buttonMediumBold,
};

var theme = {
    palette: palette,
    typography: typography,
};

var GlobalStyles = createGlobalStyle(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  /* vietnamese */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_c6Dpp_k.woff2) format('woff2');\n    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_cqDpp_k.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_fKDp.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* vietnamese */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_c6Dpp_k.woff2) format('woff2');\n    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_cqDpp_k.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_fKDp.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* vietnamese */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_c6Dpp_k.woff2) format('woff2');\n    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_cqDpp_k.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_fKDp.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n\n  /* latin-ext */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh7USSwaPGR_p.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh7USSwiPGQ.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6uyw4BMUTPHjxAwXjeu.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6uyw4BMUTPHjx4wXg.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh6UVSwaPGR_p.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh6UVSwiPGQ.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n"], ["\n  /* vietnamese */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_c6Dpp_k.woff2) format('woff2');\n    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_cqDpp_k.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_fKDp.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* vietnamese */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_c6Dpp_k.woff2) format('woff2');\n    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_cqDpp_k.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_fKDp.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* vietnamese */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_c6Dpp_k.woff2) format('woff2');\n    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_cqDpp_k.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Work Sans';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/worksans/v18/QGYsz_wNahGAdqQ43Rh_fKDp.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n\n  /* latin-ext */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh7USSwaPGR_p.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh7USSwiPGQ.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6uyw4BMUTPHjxAwXjeu.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6uyw4BMUTPHjx4wXg.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh6UVSwaPGR_p.woff2) format('woff2');\n    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Lato';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh6UVSwiPGQ.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n"])));
var templateObject_1$5;

var tagTheme = {
    cores: {
        'azul': '#21c5e5',
        'azulClaro': '#dffaff',
        'azulMedio': '#b8ebf5',
        'azulEscuro': '#009bbf',
        'azulAuxiliar': '#1b2a68',
        'azulForm': '#2d4181',
        'azulLabel': '#3F4369',
        'azulGradiente': 'linear-gradient(239deg, #91eaf3, #21c5e5)',
        'laranja': '#ffa435',
        'laranjaEscuro': '#eb8100',
        'laranjaAuxiliar': '#f7c671',
        'laranjaGradiente': 'linear-gradient(239deg, #ffd8a3 0%,#ff9e17 100%);',
        'branco': '#fff',
        'preto': '#0e111b',
        'vermelhoErro': '#fc2351',
        'vermelhoErroBackground': '#ffe8df',
        'vermelhoErroColor': '#fa6e58',
        'vermelhoErroColorEscuro': '#d94432',
        'vermelhoErroCampoObrigatorio': '#d31718',
        'verdeSucesso': '#34c41a',
        'verdeSucessoBackground': '#ebfae9',
        'cinzaMenuSuperiorEscuro': '#525252',
        'cinzaMenuSuperiorClaro': '#697481',
        'cinza100': '#f9f9f9',
        'cinza200': '#efefef',
        'cinza300': '#c0c0c0',
        'cinza400': '#999999',
        'cinza500': '#4e5464',
        'cinza600': '#131a2d',
        'TAG1-900': '#000C40',
        'TAG1-800': '#1B2A68',
        'TAG1-700': '#00518E',
        'TAG1-600': '#009BBF',
        'TAG1-400': '#21C5E5',
        'TAG1-200': '#94F2FF',
        'TAG1-100': '#CBF6FF',
        'TAG2-900': '#381700',
        'TAG2-700': '#B74D00',
        'TAG2-650-TXT': '#E16D00',
        'TAG2-600': '#EB8100',
        'TAG2-500': '#FFA435',
        'TAG2-400': '#F7C671',
        'TAG2-200': '#FFE1A7',
        'TAG2-100': '#FFF1D7',
        'CYAN-700': '#007D85',
        'INDIGO-600': '#0065DB',
        'ORANGE-700': '#C14600',
        'PINK-600': '#E1004F',
        'VIOLET-600': '#9800E0',
        'CYAN-50': '#F2FFFF',
        'INDIGO-50': '#F2F8FF',
        'ORANGE-50': '#FFF7EF',
        'PINK-50': '#FEF8FA',
        'VIOLET-50': '#F8F1FF',
        'GREY-900-TXT': '#110E22',
        'GREY-800-TXT': '#1D2130',
        'GREY-700-TXT': '#343A4F',
        'GREY-600-TXT': '#53586F',
        'GREY-500-TXT': '#676C84',
        'GREY-300-BORDER': '#D4D4D4',
        'GREY-100-BORDER-BG': '#EFEFEF',
        'GREY-50-BG': '#F9F9F9',
        'WHITE': '#FFFFFF',
        'ERROR-700': '#B72133',
        'ERROR-100': '#FFE7D9',
        'SUCCESS-700': '#347A0B',
        'SUCCESS-100': '#F0FCD2',
        'WARNING-700': '#936A03',
        'WARNING-100': '#FFF8CE',
        'INFO-700': '#3F49B5',
        'INFO-100': '#E5E9FE',
        'CTA-300': '#00A94E',
        'CTA-400': '#008F64',
        'none': 'none',
    },
    coresOpacas: {
        formBorder: 'rgba(45, 65, 129, .4)',
        formPlaceholder30: 'rgba(78, 84, 100, .3)',
        formPlaceholder40: 'rgba(78, 84, 100, .4)',
        azulButtonOpaco: 'rgba(33, 197, 229, 0.1)',
        laranjaButtonOpaco: 'rgba(255, 164, 53, 0.1)',
        brancoButtonOpaco: 'rgba(255, 255, 255, 0.1)',
        pretoButtonOpaco: 'rgba(19, 26, 45, 0.1)',
        vermelhoErroColorOpaco: 'rgba(217, 68, 50, 0.1)',
    },
    mediaQuery: {
        mobile: '520px',
        tablet: '769px',
        smallpc: '1025px',
        desktop: '1172px',
    },
    fontFamily: {
        circularStd: "'CircularStd', sans-serif",
        notoSans: "'Noto Sans', sans-serif",
        robotoSlab: "'Roboto Slab', sans-serif",
    },
    fontSize: {
        'title-l': '48px',
        'title-m': '40px',
        'title-p': '32px',
        'xxxxl': '40px',
        'xxxl': '35px',
        'xxl': '30px',
        'xl': '24px',
        'l': '20px',
        'm': '18px',
        's': '16px',
        'xs': '14px',
        'xxs': '12px',
        'xxxs': '10px',
    },
    fontWeight: {
        heavy: '900',
        xxl: '800',
        xl: '700',
        l: '600',
        m: '500',
        s: '400',
        xs: '300',
        xxs: '200',
    },
    v2: theme,
};
var TAGThemeProvider = function (_a) {
    var children = _a.children;
    return (jsxs(ThemeProvider, __assign({ theme: tagTheme }, { children: [jsx(GlobalStyles, {}), children] })));
};

var TypographyStyled = styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    var color = props.color ? theme.cores[props.color] : theme.cores.cinza500;
    var fontFamily = props.fontFamily ? theme.fontFamily[props.fontFamily] : theme.fontFamily.circularStd;
    var fontSizeDesktop = props.fontSizeDesktop ? theme.fontSize[props.fontSizeDesktop] : theme.fontSize.xl;
    var fontSizeMobile = props.fontSizeMobile ? theme.fontSize[props.fontSizeMobile] : theme.fontSize.xl;
    var fontWeight = props.fontWeight ? theme.fontWeight[props.fontWeight] : theme.fontWeight.xl;
    switch (props.variant) {
        case 'heading1':
            return css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n          @media (min-width: ", ") {\n            font-size: ", ";\n          }\n        "], ["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n          @media (min-width: ", ") {\n            font-size: ", ";\n          }\n        "])), theme.fontSize.l, fontWeight, fontFamily, color, theme.mediaQuery.desktop, theme.fontSize.xxl);
        case 'heading2':
            return css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n          @media (min-width: ", ") {\n            font-size: ", ";\n          }\n        "], ["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n          @media (min-width: ", ") {\n            font-size: ", ";\n          }\n        "])), theme.fontSize.xl, fontWeight, fontFamily, color, theme.mediaQuery.desktop, theme.fontSize.l);
        case 'heading3':
            return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n          @media (min-width: ", ") {\n            font-size: ", ";\n          }\n        "], ["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n          @media (min-width: ", ") {\n            font-size: ", ";\n          }\n        "])), theme.fontSize.xxl, fontWeight, fontFamily, color, theme.mediaQuery.desktop, theme.fontSize.xl);
        case 'text1':
            return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n        "], ["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n        "])), theme.fontSize.m, fontWeight, fontFamily, color);
        case 'text2':
            return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n        "], ["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n        "])), theme.fontSize.s, fontWeight, fontFamily, color);
        case 'text3':
            return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n        "], ["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n        "])), theme.fontSize.xs, fontWeight, fontFamily, color);
        case 'helperText':
            return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n        "], ["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n        "])), theme.fontSize.xxs, fontWeight, fontFamily, color);
        case 'customText':
        default:
            return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n          @media (min-width: ", ") {\n            font-size: ", ";\n          }\n        "], ["\n          font-size: ", ";\n          font-weight: ", ";\n          font-family: ", ";\n          color: ", ";\n\n          @media (min-width: ", ") {\n            font-size: ", ";\n          }\n        "])), fontSizeMobile, fontWeight, fontFamily, color, theme.mediaQuery.desktop, fontSizeDesktop);
    }
});
var templateObject_1$4, templateObject_2$2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

// * Exemplo de variantes no styled components: https://github.com/MaNikkel/react-ds/blob/master/src/components/Button/index.ts
var Typography$1 = React.memo(function (_a) {
    var children = _a.children, variant = _a.variant, color = _a.color, fontFamily = _a.fontFamily, fontWeight = _a.fontWeight, fontSizeMobile = _a.fontSizeMobile, fontSizeDesktop = _a.fontSizeDesktop, _b = _a.as, as = _b === void 0 ? 'span' : _b;
    return (jsx(TypographyStyled, __assign({ as: as, color: color, fontFamily: fontFamily, fontSizeDesktop: fontSizeDesktop, fontSizeMobile: fontSizeMobile, fontWeight: fontWeight, variant: variant }, { children: children })));
});

/**
 * Typography element.
 */
var Wrapper = styled.span(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    var variant = props.$variantValue, color = props.$colorValue, device = props.$device;
    return css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n      color: ", ";\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      letter-spacing: ", ";\n      font-weight: ", ";\n    "], ["\n      color: ", ";\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      letter-spacing: ", ";\n      font-weight: ", ";\n    "])), color, variant.fontFamily, variant.fontSize[device], variant.lineHeight[device], variant.letterSpacing, variant.fontWeight);
});
var templateObject_1$3, templateObject_2$1;

function useIsMobile() {
    var _a = useState(getIsMobile), isMobile = _a[0], setIsMobile = _a[1];
    useEffect(function () {
        function handleResize() {
            setIsMobile(getIsMobile());
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return isMobile;
}
function getIsMobile() {
    return window.innerWidth <= 1024;
}

/**
 * Tipographic component for design system `v2`.
 * @param props Attributes.
 * @returns React element.
 * @see https://www.figma.com/file/yZ2upzo03Ly3WRWaRLaQCD/Core-Components?node-id=1668%3A3546
 */
var Typography = function (props) {
    var className = props.className, variant = props.variant, color = props.color, _a = props.as, as = _a === void 0 ? 'span' : _a, children = props.children;
    var theme = useTheme().v2;
    var isMobile = useIsMobile();
    var variantValue = theme.typography[variant];
    var colorValue = theme.palette[color];
    var device = isMobile ? 'mobile' : 'desktop';
    return (jsx(Wrapper, __assign({ className: className, "$variantValue": variantValue, "$colorValue": colorValue, "$device": device, as: as }, { children: children })));
};

var Container$2 = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  border-radius: ", ";\n  max-width: 200px;\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  position: fixed;\n  bottom: 8px;\n  left: 8px;\n  background-color: ", ";\n  z-index: 1;\n  box-shadow: 0px 2px 8px rgba(19, 26, 45, 0.2);\n  > svg {\n    ", "\n  }\n\n  @media(min-width: ", ") {\n    bottom: 40px;\n    left: 40px;\n  }\n"], ["\n  border-radius: ", ";\n  max-width: 200px;\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  position: fixed;\n  bottom: 8px;\n  left: 8px;\n  background-color: ", ";\n  z-index: 1;\n  box-shadow: 0px 2px 8px rgba(19, 26, 45, 0.2);\n  > svg {\n    ", "\n  }\n\n  @media(min-width: ", ") {\n    bottom: 40px;\n    left: 40px;\n  }\n"])), function (props) { return props.show ? '24px 16px 16px 16px;' : '24px'; }, function (props) { return props.theme.cores.WHITE; }, function (props) { return !props.show && 'cursor: pointer;'; }, function (props) { return props.theme.mediaQuery.smallpc; });
var templateObject_1$2;

var fadein = keyframes(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  from { opacity: 0; }\n  to   { opacity: 1; }\n"], ["\n  from { opacity: 0; }\n  to   { opacity: 1; }\n"])));
var Container$1 = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation: ", " 2s;\n  h1 {\n    margin: 12px 0 4px;\n  }\n  p {\n    margin: 0;\n    margin-bottom: 8px;\n  }\n\n  p a {\n    font-family: inherit;\n    color: ", ";\n    text-decoration: underline;\n    &:hover {\n      color: ", ";\n    }\n  }\n"], ["\n  animation: ", " 2s;\n  h1 {\n    margin: 12px 0 4px;\n  }\n  p {\n    margin: 0;\n    margin-bottom: 8px;\n  }\n\n  p a {\n    font-family: inherit;\n    color: ", ";\n    text-decoration: underline;\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), fadein, function (props) { return props.theme.cores['TAG1-700']; }, function (props) { return props.theme.cores['TAG1-400']; });
var templateObject_1$1, templateObject_2;

var Container = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 8px 0;\n  background-color: ", ";\n  border: solid 1px ", ";\n  border-radius: 8px;\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 700;\n  height: 38px;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n    transition: .2s ease-in-out;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 8px 0;\n  background-color: ", ";\n  border: solid 1px ", ";\n  border-radius: 8px;\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 700;\n  height: 38px;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n    transition: .2s ease-in-out;\n  }\n"])), function (props) { return props.theme.cores[props.$backgroundColor]; }, function (props) { return props.theme.cores[props.$border]; }, function (props) { return props.theme.cores[props.$color]; }, function (props) { return props.theme.cores[props.$hover]; });
var templateObject_1;

var Button = function (_a) {
    var children = _a.children, backgroundColor = _a.backgroundColor, _b = _a.border, border = _b === void 0 ? 'none' : _b, color = _a.color, href = _a.href, onClick = _a.onClick, _c = _a.className, className = _c === void 0 ? 'button' : _c, target = _a.target, _d = _a.hover, hover = _d === void 0 ? backgroundColor : _d;
    return (jsx(Container, __assign({ "$backgroundColor": backgroundColor, "$border": border, "$color": color, "$hover": hover, className: className, href: href, onClick: onClick, target: target }, { children: children })));
};

var colors = {
    curadoria: {
        SOLID: {
            BUTTON_BACKGROUND: 'TAG1-700',
            BUTTON_HOVER: 'TAG1-800',
            BUTTON_COLOR: 'WHITE',
        },
        OUTLINE: {
            BUTTON_BACKGROUND: 'WHITE',
            BUTTON_HOVER: 'TAG1-100',
            BUTTON_COLOR: 'TAG1-700',
        },
        TITLE: 'TAG1-600',
        DEFAULT: 'TAG1-700',
        SELECTED: 'TAG1-100',
        PRIMARY: 'TAG1-400',
    },
    ineditos: {
        SOLID: {
            BUTTON_BACKGROUND: 'TAG2-650-TXT',
            BUTTON_HOVER: 'TAG2-700',
            BUTTON_COLOR: 'WHITE',
        },
        OUTLINE: {
            BUTTON_BACKGROUND: 'WHITE',
            BUTTON_HOVER: 'TAG2-100',
            BUTTON_COLOR: 'TAG2-650-TXT',
        },
        TITLE: 'TAG2-650-TXT',
        DEFAULT: 'TAG2-650-TXT',
        SELECTED: 'TAG2-100',
        PRIMARY: 'TAG2-500',
    },
    home: {
        SOLID: {
            BUTTON_BACKGROUND: 'TAG1-700',
            BUTTON_HOVER: 'TAG1-800',
            BUTTON_COLOR: 'WHITE',
        },
        SELECTED: 'TAG2-100',
        PRIMARY: 'TAG2-500',
    },
};

var CookiesInformation = function (_a) {
    var onClose = _a.onClose;
    return (jsxs(Container$1, __assign({ className: "fab-information" }, { children: [jsx(Typography$1, __assign({ as: "h1", color: "GREY-700-TXT", fontFamily: "notoSans", fontWeight: "xl", variant: "text3" }, { children: "Privacidade" })), jsxs(Typography$1, __assign({ as: "p", color: "GREY-700-TXT", fontFamily: "notoSans", fontWeight: "s", variant: "helperText" }, { children: ["Utilizamos cookies para personalizar sua experi\u00EAncia. Ao continuar, voc\u00EA concorda com este uso.", ' ', jsx("a", __assign({ href: "https://clube.taglivros.com/politica-de-privacidade-e-seguranca/", rel: "noreferrer", target: "_blank" }, { children: "Saiba mais" }))] })), jsx(Button, __assign({ backgroundColor: colors.home.SOLID.BUTTON_BACKGROUND, className: "fab-informationmodal__button", color: colors.home.SOLID.BUTTON_COLOR, hover: colors.home.SOLID.BUTTON_BACKGROUND, onClick: onClose }, { children: "Entendi" }))] })));
};

var Cookie = function () {
    return (jsxs("svg", __assign({ fill: "none", height: "32", viewBox: "0 0 32 32", width: "32", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { d: "M28.7968 14.752C28.6363 14.6309 28.4507 14.5474 28.2536 14.5077C28.0565 14.468 27.853 14.4731 27.6581 14.5227C27.335 14.6129 27.0016 14.6613 26.6661 14.6667C24.4608 14.6667 22.6661 12.872 22.6621 10.7507C22.6688 10.7053 22.6835 10.5693 22.6848 10.524C22.6935 10.3156 22.6531 10.108 22.5667 9.91804C22.4804 9.72809 22.3507 9.56111 22.1879 9.43056C22.0252 9.3 21.8341 9.20955 21.6299 9.16649C21.4258 9.12343 21.2144 9.12897 21.0128 9.18267C20.683 9.27666 20.3423 9.3273 19.9995 9.33333C17.7941 9.33333 15.9995 7.53867 15.9995 5.33333C15.9995 5.044 16.0408 4.74133 16.1315 4.37867C16.1828 4.17165 16.1837 3.95535 16.1341 3.74791C16.0846 3.54047 15.986 3.34795 15.8466 3.18651C15.7072 3.02507 15.5312 2.89941 15.3332 2.82009C15.1352 2.74077 14.9211 2.71011 14.7088 2.73067C11.4067 3.03843 8.33948 4.57102 6.11072 7.0268C3.88196 9.48258 2.65314 12.6837 2.66612 16C2.66612 23.352 8.64745 29.3333 15.9995 29.3333C23.3515 29.3333 29.3328 23.352 29.3328 16C29.3328 15.9347 29.3288 15.8707 29.3235 15.7867C29.319 15.5857 29.2693 15.3884 29.1781 15.2093C29.0869 15.0301 28.9566 14.8739 28.7968 14.752ZM15.9995 26.6667C10.1181 26.6667 5.33278 21.8813 5.33278 16C5.32327 13.631 6.10639 11.327 7.55752 9.45446C9.00865 7.58196 11.0444 6.24863 13.3408 5.66667C13.4282 7.37431 14.1677 8.98328 15.4066 10.1617C16.6456 11.3401 18.2896 11.9981 19.9995 12L20.1341 11.9987C20.4401 13.4897 21.2464 14.8314 22.4193 15.8013C23.5923 16.7713 25.0615 17.3114 26.5835 17.332C25.9248 22.588 21.4301 26.6667 15.9995 26.6667Z", fill: "#092346" }), jsx("path", { d: "M16.666 17.3333C17.7706 17.3333 18.666 16.4379 18.666 15.3333C18.666 14.2288 17.7706 13.3333 16.666 13.3333C15.5614 13.3333 14.666 14.2288 14.666 15.3333C14.666 16.4379 15.5614 17.3333 16.666 17.3333Z", fill: "#092346" }), jsx("path", { d: "M11.334 13.3333C12.4386 13.3333 13.334 12.4379 13.334 11.3333C13.334 10.2288 12.4386 9.33334 11.334 9.33334C10.2294 9.33334 9.33398 10.2288 9.33398 11.3333C9.33398 12.4379 10.2294 13.3333 11.334 13.3333Z", fill: "#092346" }), jsx("path", { d: "M10 18.6667C11.1046 18.6667 12 17.7712 12 16.6667C12 15.5621 11.1046 14.6667 10 14.6667C8.89543 14.6667 8 15.5621 8 16.6667C8 17.7712 8.89543 18.6667 10 18.6667Z", fill: "#092346" }), jsx("path", { d: "M20.666 22.6667C21.7706 22.6667 22.666 21.7712 22.666 20.6667C22.666 19.5621 21.7706 18.6667 20.666 18.6667C19.5614 18.6667 18.666 19.5621 18.666 20.6667C18.666 21.7712 19.5614 22.6667 20.666 22.6667Z", fill: "#092346" }), jsx("path", { d: "M14 24C15.1046 24 16 23.1046 16 22C16 20.8954 15.1046 20 14 20C12.8954 20 12 20.8954 12 22C12 23.1046 12.8954 24 14 24Z", fill: "#092346" })] })));
};

var CookiesFab = function () {
    var _a = useState(false), showInformation = _a[0], setShowInformation = _a[1];
    var _b = useState(false), showModal = _b[0], setShowModal = _b[1];
    var handleOnClose = function (e) {
        e.stopPropagation();
        if (typeof window !== 'undefined') {
            localStorage.setItem('cookies_accepted', 'true');
        }
        setShowModal(false);
    };
    var showInfomationCookie = function () { return setShowInformation(true); };
    useEffect(function () {
        if (typeof window !== 'undefined' && !localStorage.getItem('cookies_accepted')) {
            setShowModal(true);
        }
        setTimeout(function () {
            showInfomationCookie();
        }, 5000);
        window.addEventListener('scroll', function () {
            setTimeout(function () {
                showInfomationCookie();
            }, 100);
        });
        return function () { return window.removeEventListener('scroll', showInfomationCookie); };
    }, []);
    return (jsx(TAGThemeProvider, { children: showModal &&
            jsxs(Container$2, __assign({ className: "book-metadata-header", onClick: function () { return setShowInformation(true); }, show: showInformation }, { children: [jsx(Cookie, {}), showInformation && jsx(CookiesInformation, { onClose: handleOnClose })] })) }));
};

var MILLISECONDS_IN_1_DAY = 1000 * 60 * 60 * 24;
var MILLISECONDS_IN_1_HOUR = MILLISECONDS_IN_1_DAY / 24;
var MILLISECONDS_IN_1_MINUTE = MILLISECONDS_IN_1_HOUR / 60;
var MILLISECONDS_IN_1_SECOND = 1000;
function useCountDown(end, fps) {
    if (fps === void 0) { fps = 1; }
    var _a = useState(getTimeLeft), timeLeft = _a[0], setTimeLeft = _a[1];
    var period = useMemo(getPeriod, [timeLeft]);
    useEffect(function () {
        var timerInterval = Math.round(1000 / fps);
        var timerId = window.setInterval(function () { return setTimeLeft(getTimeLeft()); }, timerInterval);
        return function () { return window.clearInterval(timerId); };
    }, [end, fps]);
    return period;
    function getTimeLeft() {
        return end - Date.now();
    }
    function getPeriod() {
        var timestamp = timeLeft;
        var days = Math.floor(timestamp / MILLISECONDS_IN_1_DAY);
        timestamp %= MILLISECONDS_IN_1_DAY;
        var hours = Math.floor(timestamp / MILLISECONDS_IN_1_HOUR);
        timestamp %= MILLISECONDS_IN_1_HOUR;
        var minutes = Math.floor(timestamp / MILLISECONDS_IN_1_MINUTE);
        timestamp %= MILLISECONDS_IN_1_MINUTE;
        var seconds = Math.floor(timestamp / MILLISECONDS_IN_1_SECOND);
        var milliseconds = timestamp % MILLISECONDS_IN_1_SECOND;
        return { days: days, hours: hours, minutes: minutes, seconds: seconds, milliseconds: milliseconds, expired: days < 0 };
    }
}

export { Button$1 as Button, CookiesFab, Pill, Select, TAGThemeProvider, Typography$1 as Typography, Typography as TypographyV2, tagTheme, theme as themeV2, useCountDown, useIsMobile };
